import React from 'react';
import Skeleton from 'react-loading-skeleton';

/**Metric card which displays data in plain card*/
const MetricCard = ({ 
  svgsrc,
  title,
  subTitle = '',
  titleClasses = '',
  headerClasses='',
  subTitleClasses='',
  metricValue,
  metricValueSuffix,
  loading,
  loaderHeight,
  btnText = '',
  metricClasses='flex mt-6 text-gray-500',
  svgClasses='',
  btnAction = () => {},
  classes = '' 
}) => {
  if (loading) {
    return (
      <div className={classes.replace('flex', '')}>
        <Skeleton width='100%' height={loaderHeight} />
      </div>
    );
  }

  return (
    <div className={'border bg-white border-gray-200 rounded-md flex flex-col ' + classes}>
      <div className={`p-5 flex-auto ${headerClasses}`}>
        <div className='flex flex-row items-center'>
          <img className={`inline-block h-7 ${svgClasses}`} src={svgsrc} alt='metric card avatar' />
          <div>
            <span className={`text-sm font-normal ml-3 ${titleClasses ? titleClasses : 'text-gray-600'}`}>{title}</span>
            {subTitle && <span className={`${subTitleClasses} +  ml-3 block`}>{subTitle}</span>} 
          </div>
        </div>

        {metricValue && (
          <div className={metricClasses}>
            {metricValue}
            <dt className='text-xs font-normal ml-3' style={{ paddingTop: '0.85rem'}}>
              {metricValueSuffix}
            </dt>
          </div>
        )}
      </div>
      {btnText && 
        <div className='bg-gray-50 py-5 px-6 rounded-b-md'>
          <div className='cursor-pointer text-blue-600 text-sm font-semibold' onClick={btnAction}>
            {btnText}
          </div>
        </div>
      }
    </div>
  );
};

export default MetricCard;